// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lite-compare-header-mobile{position:absolute;top:0;left:0;width:100%;height:62px!important;margin-top:-62px}.lite-compare-header-mobile__scroll{left:0;opacity:0;width:100%;padding:12px 0;background:#fff;border-bottom:1px solid #d9e9ed;z-index:25}.lite-compare-header-mobile__scroll.fix-scroll-block{opacity:1}", ""]);
// Exports
module.exports = exports;
